<!-- <marquee onmouseover="this.stop();" onmouseout="this.start();"><a routerLink="/apply" mat-stroked-button>Apply</a> for All
	India Pilot Aptitude Test now! Last Date 31 Oct 2020.
</marquee> -->

<mat-card
  fxLayout="row"
  fxLayout.xs="column"
  fxLayoutAlign="space-around"
  style="padding:10px"
>
  <div fxFlex="40">
    <img
      width="100%"
      src="https://firebasestorage.googleapis.com/v0/b/top-crew.appspot.com/o/TCA-ASSETS%2Fhome.webp?alt=media&token=91b42212-b3b2-4eb1-9f5c-8819b4e85d9c"
    />
  </div>
  <div fxFlex="40">
    <h1>Give wings to your dreams!</h1>
    <p>Stop DREAMING now!</p>
    <p>
      its time to make it happen, Does'nt matter what ever is your background.
      Top Crew is here to make your dream come true.
      <a href="https://wa.me/9180944 49995" target="_blank">ASK US HOW</a> ?
    </p>
  </div>
</mat-card>

<h1 fxLayoutAlign="center">How to Become a Pilot?</h1>

<div
  fxLayout="row"
  fxLayout.xs="column"
  fxLayoutAlign="space-around"
  style="text-align:center;"
>
  <mat-card fxFlex="25">
    <i class="icon ion-md-checkmark"></i>
    <mat-card-title>
      <a routerLink="/apply">Register</a>
    </mat-card-title>
    <mat-card-content>
      <p>
        Apply Online & Make sure you are
        <a routerLink="/eligibility">eligible</a>.
      </p>
    </mat-card-content>
    <mat-card-actions>
      <div fxLayoutAlign="center" fxHide fxShow.gt-xs>
        <i class="icon ion-md-arrow-forward"></i>
      </div>
      <div fxLayoutAlign="center" fxHide fxShow.xs>
        <i class="icon ion-md-arrow-down"></i>
      </div>
    </mat-card-actions>
  </mat-card>

  <mat-card fxFlex="25">
    <i class="icon ion-md-school"></i>
    <mat-card-title>
      <a routerLink="/eligibility">Selection</a>
    </mat-card-title>
    <mat-card-content>
      <p>Complete an assessment process in order to qualify for selection</p>
    </mat-card-content>
    <mat-card-actions>
      <div fxLayoutAlign="center" fxHide fxShow.gt-xs>
        <i class="icon ion-md-arrow-forward"></i>
      </div>
      <div fxLayoutAlign="center" fxHide fxShow.xs>
        <i class="icon ion-md-arrow-down"></i>
      </div>
    </mat-card-actions>
  </mat-card>

  <mat-card fxFlex="25">
    <i class="icon ion-md-airplane"></i>
    <mat-card-title> Training </mat-card-title>
    <mat-card-content>
      <p>Be a part of the ever-growing Aviation family!</p>
    </mat-card-content>
    <mat-card-actions>
      <i class="icon ion-md-medal"></i>
    </mat-card-actions>
  </mat-card>
</div>

<!-- <h1 fxLayoutAlign="center">Any Queries?</h1>

<div fxLayout="column" fxLayoutAlign="space-evenly center">

	<mat-card fxFlex="60" fxFlex.xs="100" *ngIf="!submitted">
		<div fxLayout="row" fxLayout.xs="column" style="padding:0 10px">
			  <mat-form-field fxFlex="33">
				  <input required matInput type="text" [formControl]="nameC" placeholder="Name" [(ngModel)]="query.name" name="name">
          <mat-error *ngIf="nameC.invalid">Enter a Name</mat-error>
			  </mat-form-field>

        <mat-form-field fxFlex="33">
          <input required matInput type="email" [formControl]="emailC"  placeholder="Email" [(ngModel)]="query.email" name="email">
          <mat-error *ngIf="emailC.invalid">Enter Valid Email</mat-error>
        </mat-form-field>
  
        <mat-form-field fxFlex="33">
          <input required type="tel" matInput [formControl]="phoneC"  placeholder="Phone"  [(ngModel)]="query.phone" name="phone"> 
          <mat-error *ngIf="phoneC.invalid">Enter a valid Phone</mat-error>
        </mat-form-field>
    </div>
    <div fxLayout="row" fxLayout.xs="column" >
        <mat-form-field fxFlex="100">
          <textarea required  type="text" matInput #input [formControl]="messageC" placeholder="Message" [(ngModel)]="query.message" name="message"></textarea>
           <mat-error *ngIf="messageC.invalid">Enter a message</mat-error>
           <mat-hint align="end">{{input.value?.length || 0}}/256</mat-hint>
        </mat-form-field>
    </div>
    <div fxLayoutAlign="center" >
      <button mat-raised-button [disabled]="!nameC.valid || !emailC.valid || !phoneC.valid || !messageC.valid" type="submit"  color="warn" (click)="addQuery()">Submit</button>
    </div>

  </mat-card>
 <mat-card *ngIf="submitted">
   <mat-card-content><p>Submitted Succesfully. We will get back to you.</p></mat-card-content>
 </mat-card>
</div> -->
